import { LookupType, WithId } from "./data/lookups";
import { getDish } from "./api";
import { withLoadDelay } from "./utils/loadDelay";
import { trackLookupAccess } from "./utils/lookupDiagnostics";

export function createLookup<T>(
  data: T[],
  getKey: (entity: T) => number | string,
  label = "createLookup",
) {
  const newLookup: LookupType<T> = {};
  data.forEach((entity) => {
    newLookup[getKey(entity)] = entity;
  });
  return trackLookupAccess(newLookup, label);
}

export function createByIdLookup<T extends WithId>(data: T[]) {
  return createLookup(data, (d) => d.id, "createByIdLookup");
}

export function createGeneralLookup<T, U>(
  data: T[],
  getId: (item: T) => number[],
  mapper: (item: T) => U,
) {
  const newLookup: LookupType<U> = {};
  data.forEach((entity) => {
    getId(entity).forEach((id) => {
      newLookup[id] = mapper(entity);
    });
  });
  return trackLookupAccess(newLookup, "createGeneralLookup");
}

export async function loadDishModification(
  dishId: string | number | undefined,
) {
  return (await withLoadDelay(getDish({ path: { dishId: String(dishId) } })))
    .data;
}
